import { atom } from "recoil";


const CrumbsItemAtom = atom({
    default: '',
    key: 'CrumbsItem'
})

export default CrumbsItemAtom;